module.exports = __webpack_public_path__ + "img/sentDocumentSuccess.e359f26f.gif";